import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as BellIcon } from "../../../../images/svgs/icons/notification.svg";
import Notification from '../../../ReusableComponents/Notification'
import styles from './styles.module.css';

const NotificationPopover = () => {
    const [toggle, setToggle] = useState(false);
    const NavLinks = () => (
        <div className={styles.navlinks}>
            <NavLink exact to="/notifications" activeClassName={styles.active}><span>Read All</span></NavLink>
        </div>
    )
    return (
        <div className={`${styles.userNotify} ${toggle && styles.active}`} onClick={() => setToggle(!toggle)}>
            <div className={styles.userNotifyIcon}>
                <BellIcon />
            </div>
            <div className={`${styles.modal} ${toggle && styles.toggle}`}>
                <div className={styles.head}>
                    <h3>Notifications</h3>
                    {NavLinks()}
                </div>
                <div className={styles.body}>
                    <Notification
                        coin={0.00238799}
                        coinType={'BTC'}
                        date={'21-06-22'}
                        time={'20:20:09'}
                    />
                    <Notification
                        coin={0.00238799}
                        coinType={'BTC'}
                        date={'21-06-22'}
                        time={'20:20:09'}
                    />
                    <Notification
                        coin={0.00238799}
                        coinType={'BTC'}
                        date={'21-06-22'}
                        time={'20:20:09'}
                    />
                </div>
            </div>
        </div>
    )
}

export default NotificationPopover;